namespace Matrix.Administration {
    export interface GroupRow {
        GroupId?: string;
        Name?: string;
        GroupType?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        GrantedPermissions?: string[];
        Roles?: string[];
        TransitivePermissions?: string[];
    }

    export namespace GroupRow {
        export const idProperty = 'GroupId';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'Administration.Group';
        export const lookupKey = 'Administration.Group';

        export function getLookup(): Q.Lookup<GroupRow> {
            return Q.getLookup<GroupRow>('Administration.Group');
        }
        export const deletePermission = 'Administration:Security';
        export const insertPermission = 'Administration:Security';
        export const readPermission = 'Administration:Security';
        export const updatePermission = 'Administration:Security';

        export declare const enum Fields {
            GroupId = "GroupId",
            Name = "Name",
            GroupType = "GroupType",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            GrantedPermissions = "GrantedPermissions",
            Roles = "Roles",
            TransitivePermissions = "TransitivePermissions"
        }
    }
}
